const informationRoutes = [
  {
    path: "/dataStatistics",
    name: "dataStatistics",
    component: () => import("@/views/information/dataStatistics.vue"),
    meta: {
      title: "数据统计",
      keepAlive: true,
    },
  },
  {
    path: "/balanceStatistics",
    name: "balanceStatistics",
    component: () => import("@/views/information/balanceStatistics.vue"),
    meta: {
      title: "余额统计",
      keepAlive: true,
    },
  },
  {
    path: "/media",
    name: "media",
    component: () => import("@/views/information/media.vue"),
    meta: {
      title: "媒体列表",
      // keepAlive:true
    },
  },
  {
    path: "/extensionBit",
    name: "extensionBit",
    component: () => import("@/views/information/extensionBit.vue"),
    meta: {
      title: "推广位管理",
      // keepAlive:true
    },
  },
  {
    path: "/dataExtension",
    name: "dataExtension",
    component: () => import("@/views/information/dataExtension.vue"),
    meta: {
      title: "推广位统计",
      keepAlive: true,
    },
  },
  {
    path: "/dataOrderShare",
    name: "dataOrderShare",
    component: () => import("@/views/information/dataOrderShare.vue"),
    meta: {
      title: "订单分享统计",
      keepAlive: true,
    },
  },
  {
    path: "/activeUser",
    name: "activeUser",
    component: () => import("@/views/information/activeUser.vue"),
    meta: {
      title: "激活用户统计",
      keepAlive: true,
    },
  },
];

export default informationRoutes;
